// test1499
(1499 && 0);
